import React, { useEffect, useState } from "react";
import { Box, SimpleGrid, useToast, Flex, Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import CategoryTable from "./components/CategoryTable";
import ProductTable from "./components/ProductTable";
import { menuService } from '../../../services/menuService';

export default function Menu() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const toast = useToast();

  const fetchMenuData = async () => {
    try {
      setLoading(true);
      const [categoriesResponse, productsResponse] = await Promise.all([
        menuService.getCategories(),
        menuService.getProducts()
      ]);

      setCategories(categoriesResponse.data);
      setProducts(productsResponse.data);
    } catch (error) {
      console.error('Fetch menu data error:', error);
      toast({
        title: "Hata",
        description: "Menü verileri yüklenirken bir hata oluştu",
        status: "error",
        duration: 3000
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMenuData();
  }, []);

  const handleAddCategory = async (formData) => {
    try {
      await menuService.addCategory(formData);
      fetchMenuData();
      toast({
        title: "Başarılı",
        description: "Kategori başarıyla eklendi",
        status: "success",
        duration: 2000
      });
    } catch (error) {
      toast({
        title: "Hata",
        description: "Kategori eklenirken bir hata oluştu",
        status: "error",
        duration: 3000
      });
    }
  };

  const handleAddProduct = async (formData) => {
    try {
      const response = await menuService.addProduct(formData);
      if (response.success) {
        setProducts(prevProducts => [...prevProducts, response.data]);
        toast({
          title: "Başarılı",
          description: "Ürün başarıyla eklendi",
          status: "success",
          duration: 2000
        });
      }
    } catch (error) {
      toast({
        title: "Hata",
        description: "Ürün eklenirken bir hata oluştu",
        status: "error",
        duration: 3000
      });
    }
  };

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Tabs variant="soft-rounded" colorScheme="red">
        <TabList mb="1em">
          <Tab _selected={{ color: 'white', bg: '#e45858' }}>Kategoriler</Tab>
          <Tab _selected={{ color: 'white', bg: '#e45858' }}>Ürünler</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <CategoryTable 
              categories={categories}
              setCategories={setCategories}
              onAddCategory={handleAddCategory}
              isLoading={loading}
              onRefresh={fetchMenuData}
            />
          </TabPanel>
          <TabPanel>
            <ProductTable
              tableData={products}
              categories={categories}
              setTableData={setProducts}
              onAddProduct={handleAddProduct}
              isLoading={loading}
              onRefresh={fetchMenuData}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
